import { AccountsContext } from '@paperstac/common/lib/components/AccountsProvider';
import { IdentityContext } from '@paperstac/common/lib/components/IdentityProvider';
import DelayRender from '@paperstac/ui/lib/DelayRender';
import React from 'react';
import AuthOverlay from './AuthOverlay/AuthOverlay';
import { AUTH_OVERLAY_VIEWS } from './AuthOverlay/AuthOverlayProvider';
import IdentityManager from './IdentityManager';

const RequireCurrentAccount = React.memo(({ children }) => {
  const { uid } = React.useContext(IdentityContext);
  const { currentAccount } = React.useContext(AccountsContext);
  if (!uid)
    return (
      <DelayRender>
        <AuthOverlay view={AUTH_OVERLAY_VIEWS.LOGIN} />
      </DelayRender>
    );
  if (!currentAccount) return <IdentityManager />;
  return children;
});

RequireCurrentAccount.propTypes = {};

RequireCurrentAccount.defaultProps = {};

RequireCurrentAccount.displayName = 'RequireCurrentAccount';

export default RequireCurrentAccount;
